/*
For product thumbnails. Some hack so they work...
*/

(() => {
  function initGallery(gallery) {
    if (!gallery || gallery.dataset.msThumbInit === "1") return;

    const getThumbsRoot = () => gallery.querySelector(".media-gallery__mobile-thumbnails");
    const scrollTo = (btn) => {
      if (!btn) return;
      btn.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    };

    function bind() {
      const thumbsRoot = getThumbsRoot();
      if (!thumbsRoot) return;

      // Mark gallery as initialized once we have thumbs
      gallery.dataset.msThumbInit = "1";

      // Click: keep clicked thumb visible, then follow the new selected thumb
      thumbsRoot.addEventListener(
        "click",
        (e) => {
          const btn = e.target.closest("button");
          if (!btn) return;
          scrollTo(btn);
          setTimeout(() => {
            const active = thumbsRoot.querySelector('[aria-selected="true"]');
            scrollTo(active);
          }, 80);
        },
        true
      );

      // When selection changes, center active thumb
      const obs = new MutationObserver((muts) => {
        for (const m of muts) {
          if (m.type === "attributes" && m.attributeName === "aria-selected") {
            if (m.target.getAttribute("aria-selected") === "true") {
              scrollTo(m.target);
              return;
            }
          }
        }
      });

      thumbsRoot.querySelectorAll("button").forEach((btn) => {
        obs.observe(btn, { attributes: true });
      });

      // Initial centering
      setTimeout(() => scrollTo(thumbsRoot.querySelector('[aria-selected="true"]')), 120);

      // If the theme replaces thumbnails inside the same gallery, re-init
      const rebinder = new MutationObserver(() => {
        // remove init mark so we can init again
        gallery.dataset.msThumbInit = "0";
        setTimeout(() => initGallery(gallery), 50);
      });
      rebinder.observe(thumbsRoot, { childList: true, subtree: true });
    }

    bind();
  }

  function initAll() {
    document.querySelectorAll("media-gallery").forEach(initGallery);
  }

  // Variant change in Shopify themes often triggers DOM replacement.
  // We do not rely on specific event names, we just re-scan after any changes.
  const pageObserver = new MutationObserver(() => {
    // debounce
    clearTimeout(initAll._t);
    initAll._t = setTimeout(initAll, 80);
  });
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
